window.dazContracts = window.dazContracts || {};
window.dazContracts["IMintpassMintable"] = [
    {
        "inputs": [
            {
                "internalType": "uint256[]",
                "name": "tokens",
                "type": "uint256[]"
            },
            {
                "internalType": "uint256[]",
                "name": "mintCounts",
                "type": "uint256[]"
            }
        ],
        "name": "mintWithPass",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    }
];
